import { createSelector } from '@ngrx/store';
import * as fromApp from '../reducers/app.reducer';
import * as fromError from '../reducers/error.reducer';

const selectError = (state: fromApp.AppState) => state.error;

export const selectErrorCurrent = createSelector(selectError, (state: fromError.State) => state.current);

export const selectErrorNext = createSelector(selectError, (state: fromError.State) => state.current[0]);

export const selectErrorPrevious = createSelector(selectError, (state: fromError.State) => state.previous);
